/**
 * File forms.js
 *
 * Handles any custom forms js
 */


(function ($) {
    $(function () {
      $('.modop-forms').find('button[type=submit]').append('<img src="/wp-content/themes/modop/assets/img/arrow-small.svg" alt="modop cta arrow"/>');
      $('._form').find('button[type=submit]').append('<img src="/wp-content/themes/modop/assets/img/arrow-small.svg" alt="modop cta arrow"/>');
    });

})(jQuery);